import { Component, Input, OnInit } from "@angular/core";
import { Util } from "../../../util/util";

@Component({
  selector: "card-info-paciente-component",
  templateUrl: "card-info-paciente-component.html",
  styleUrls: ["./card-info-paciente-component.scss"],
})
export class CardInfoPacienteComponent implements OnInit {
  @Input() profissionalInfo: any = {};
  @Input() infoUser: any = {};
  cabecalho = false;

  constructor() {}

  ngOnInit() {}

  getCNSFormat(text) {
    return Util.formatarCpfCns(text);
  }

  getTextFormat(text) {
    return Util.getTextFormat(text);
  }

  expandirCabecalho() {
    this.cabecalho = !this.cabecalho;
  }
}
